<p-card styleClass="flex flex-col w-full p-4">
    <ng-template pTemplate="header">
        <h2>Security Awareness Stats</h2>
    </ng-template>
    <div class="flex flex-row gap-4">
        <!-- Risk Score Chart -->
        <div class="w-1/2 flex flex-col justify-center">
            <div class="chart-container">
                <canvas baseChart
                    [data]="riskScoreChartData()"
                    [options]="riskScoreChartOptions"
                    [type]="'line'">
                </canvas>
            </div>
            <div class="text-center">
                <p>Average: {{ knowBe4Averages().riskAverage | number:'1.2-2' }} | Goal: &lt;= 20</p>
            </div>
        </div>

        <!-- Metrics Chart -->
        <div class="w-1/2 flex flex-col justify-center">
            <div class="chart-container">
                <canvas baseChart
                    [data]="metricsChartData()"
                    [options]="metricsChartOptions"
                    [type]="'line'">
                </canvas>
            </div>
            <div class="text-center">
                <p>Average: {{ knowBe4Averages().phishAverage | number:'1.2-2' }}% | Goal: &lt;= 4%</p>
            </div>
        </div>
    </div>
</p-card> 